import type {ReactElement} from 'react';

export const CREDITS_MODAL_HEIGHT_TRANSITION = {duration: 0.3, ease: 'easeInOut'} as const;

export interface CreditsModalContentProps {
  children: ReactElement;
}
